import styled from 'styled-components'

export const CatalogItemDetailsSectionStyled = styled.div`
  padding-top: ${(props) => props.theme.typography.pxToRem(32)};
`
